import Cookie from 'js-cookie';
import store from '@/store';
import axios from 'axios';

async function hasPermission(token, routeName) {
  const response = await axios.get(`${process.env.VUE_APP_BASE_URL}api/permissoes/perfil/${routeName}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
}

export default {
  auth(to, from, next){

    const token = store.state.token;

    if(!token){
      next('/Entrar');
    }
      switch (to.name) {
        case 'Inicio':
        case 'Funcionarios':
        case 'Almoxarifado':
        case 'Ajuda':
        case 'Adicionar Funcionario':
        case 'Adicionar Curriculos':
        case 'Editar Curriculos':
        case 'Cargas':
        case 'Gestao de Veiculos':
        case 'Adicionar Veículos':
        case 'Editar Veículos':
        case 'Detalhes Veículos':
        case 'Manutenção':
        case 'Adicionar Manutenção':
        case 'Detalhes Manutenção':
        case 'Detalhes Placa':
          next();
          break;
        default:
          hasPermission(token, to.name)
          .then(hasPermission => {
              // 1 = true / 0 = false
            if (!hasPermission) {
             alert('Usuário não tem permissão')
               // Se não tiver permissão, redirecione de volta à rota de onde veio
              next(from.path);
            } else {
              // Se tiver permissão, continue para a próxima rota
              next();
            }
          })
          .catch(error => {
            if(error.response.data.error == 'Token inválido ou expirado'){
              store.commit('removeToken');
              store.commit('removeUser');  
              Cookie.remove('_myapp_token');
              next('/Entrar');
            }
            alert('Erro ao verificar permissão');
          });          
      }
  },

  removeToken(to, from, next){
    store.commit('removeToken');
    store.commit('removeUser');  
    Cookie.remove('_myapp_token');
    next();
  },

}
